<template>
  <div class="container huninnFont">
    <h1>讚數計算器</h1>
    <CForm>
      <CRow class="mb-3 d-flex">
        <CCol xs="6" md="3">
          <CFormCheck
            v-model="isRecommended"
            id="isRecommended"
            label="推薦風格"
            class="d-inline-flex align-item-center"
          ></CFormCheck>
        </CCol>
        <CCol xs="6" md="3">
          <CFormCheck
            v-model="hasBrand"
            id="hasBrand"
            label="有無品牌"
            class="d-inline-flex align-item-center"
          ></CFormCheck>
        </CCol>
        <CCol xs="6" md="3">
          <CFormCheck
            v-model="isLatest"
            id="isLatest"
            label="服裝最新"
            class="d-inline-flex align-item-center"
          ></CFormCheck>
        </CCol>
        <CCol xs="6" md="3">
          <CFormCheck
            v-model="isToolLatest"
            id="isToolLatest"
            label="道具最新"
            class="d-inline-flex align-item-center"
          ></CFormCheck>
        </CCol>
      </CRow>
      <CRow class="mb-3 align-items-center justify-content-evenly">
        <CCol md sm="5" class="mb-3">
          <CFormFloating>
            <CFormInput
              placeholder="name@example.com"
              id="originalScore"
              v-model.number="originalScore"
              @input="validateScore"
            />
            <CFormLabel for="originalScore">服裝原始分數</CFormLabel>
          </CFormFloating>
        </CCol>
        <CCol md sm="5" class="mb-3">
          <CFormFloating>
            <CFormInput
              placeholder="name@example.com"
              id="extraScore"
              v-model.number="extraScore"
            />
            <CFormLabel for="extraScore">拍照道具原始分數</CFormLabel>
          </CFormFloating>
        </CCol>
      </CRow>
      <CRow class="mb-3 justify-content-center">
        <CCol xs="3" sm="2" md="2">
          <CFormLabel for="type">服裝件數</CFormLabel>
          <CFormSelect size="sm" class="w-100" v-model="category">
            <option value="3">3</option>
            <option value="4">4</option>
          </CFormSelect>
        </CCol>
      </CRow>
      <CRow class="mb-3 justify-content-center">
        <CCol xs="3" sm="2" md="2">
          <CFormLabel for="type">稀有</CFormLabel>
          <CFormSelect size="sm" class="w-100" v-model="type">
            <option value="WR">WR</option>
            <option value="ER">ER/RR/FR</option>
            <option value="others">其他</option>
          </CFormSelect>
        </CCol>
      </CRow>
      <CRow class="mb-3 justify-content-center">
        <CCol xs="3" sm="2" md="2">
          <CFormLabel for="songPeople">歌曲人數</CFormLabel>
          <CFormSelect size="sm" class="w-100" v-model="songPeople">
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
          </CFormSelect>
        </CCol>
      </CRow>
      <CRow class="mb-3" >
        <CCol xs="12" class="text-center">
        <CFormCheck
          v-model="hasSmileCard"
          id="hasSmileCard"
          label="微笑友卡"
          class="d-inline-flex"
        ></CFormCheck>
        </CCol>
      </CRow>
    </CForm>
    <hr class="partial-divider">
    <div class="row mt-3">
      <h2>服裝</h2>
      <p>服裝原始: {{ originalScore }}</p>
      <p>拍照道具: {{ extraScore }}</p>
      <p>最新加成: {{ latestBonus }}</p>
      <p>推薦造型: {{ recommendedBonus }}</p>
      <p>同款品牌: {{ brandBonus }}</p>
      <p>稀有獎勵: {{ rareBonus }}</p>
      <h3>服裝小計: {{ clothingSubtotal }}</h3>
      <hr class="partial-divider">
      <h2>友卡加成</h2>
      <p>推薦團體: {{ recommendedGroup }} {{ hasSmileCard ? " x 2" : "" }}</p>
      <p>團體色彩: {{ groupColor }} {{ hasSmileCard ? " x 2" : "" }}</p>
      <p>團體設計: {{ groupDesign }} {{ hasSmileCard ? " x 2" : "" }}</p>
      <p>團體等級: {{ groupLevel }} {{ hasSmileCard ? " x 2" : "" }}</p>
      <h3>友卡加成: {{ friendCardBonus }}</h3>
    </div>
    <hr class="partial-divider">
    <div class="result mt-3">
      <h2>總分: {{ totalScore }}</h2>
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";

export default {
  setup() {
    const isLatest = ref(false);
    const isToolLatest = ref(false);
    const hasBrand = ref(true);
    const originalScore = ref(null);
    const category = ref(3);
    const extraScore = ref(null);
    const isRecommended = ref(false);
    const type = ref("WR");
    const songPeople = ref(2);
    const hasSmileCard = ref(false);
    const latestBonus = ref(0);
    const recommendedBonus = ref(0);
    const brandBonus = ref(0);
    const rareBonus = ref(0);
    const clothingSubtotal = ref(0);
    const recommendedGroup = ref(0);
    const groupColor = ref(0);
    const groupDesign = ref(0);
    const groupLevel = ref(0);
    const friendCardBonus = ref(0);
    const totalScore = ref(0);
    const error = ref("");

    const validateScore = () => {
      if (originalScore.value === "" || originalScore.value === null) {
        error.value = "原始分數不可為空";
      } else if (isNaN(originalScore.value)) {
        error.value = "請輸入數字";
      } else {
        error.value = "";
      }
    };
    const calculateScore = () => {
      // Calculate clothing subtotal
      validateScore();
      if (error.value) {
        clothingSubtotal.value = 0;
        friendCardBonus.value = 0;
        totalScore.value = 0;
        return;
      }

      if (isLatest.value) {
        latestBonus.value = 200 * category.value;
      } else {
        latestBonus.value = 0;
      }
    
      if (isToolLatest.value) {
        latestBonus.value = latestBonus.value + 200;
      } 

      if (isRecommended.value) {
        recommendedBonus.value = 500;
      } else {
        recommendedBonus.value = 0;
      }

      if (type.value === "WR") {
        brandBonus.value = 600;
        rareBonus.value = 300;
      } else if (type.value === "ER") {
        brandBonus.value = 300;
        rareBonus.value = 300;
      } else {
        brandBonus.value = 300;
        rareBonus.value = 0;
      }
      if(hasBrand.value == 0){
        brandBonus.value = 0;
      }
      clothingSubtotal.value =
        originalScore.value +
        extraScore.value +
        brandBonus.value +
        rareBonus.value +
        latestBonus.value +
        recommendedBonus.value;

      // Calculate friend card bonus
      const recommendedGroupScores = [700, 800, 900, 1000, 1100];
      const groupColorScores = [400, 500, 600, 700, 800];
      const groupDesignScores = [400, 500, 600, 700, 800];
      const groupLevelScores = [200, 300, 400, 500, 600];

      if (isRecommended.value) {
        recommendedGroup.value = recommendedGroupScores[songPeople.value - 2];
      } else {
        recommendedGroup.value = 0;
      }
      groupColor.value = groupColorScores[songPeople.value - 2];
      groupDesign.value = groupDesignScores[songPeople.value - 2];
      groupLevel.value = groupLevelScores[songPeople.value - 2];

      let friendCardSubtotal =
        recommendedGroup.value +
        groupColor.value +
        groupDesign.value +
        groupLevel.value;

      if (hasSmileCard.value) {
        friendCardSubtotal *= 2;
      }

      friendCardBonus.value = friendCardSubtotal;

      // Calculate total score
      totalScore.value = clothingSubtotal.value + friendCardBonus.value;
    };
    watch(
      [
        isLatest,
        isToolLatest,
        hasBrand,
        originalScore,
        category,
        extraScore,
        isRecommended,
        type,
        songPeople,
        hasSmileCard,
      ],
      calculateScore,
    );

    return {
      isLatest,
      isToolLatest,
      hasBrand,
      originalScore,
      category,
      extraScore,
      isRecommended,
      type,
      songPeople,
      hasSmileCard,
      latestBonus,
      recommendedBonus,
      brandBonus,
      rareBonus,
      clothingSubtotal,
      recommendedGroup,
      groupColor,
      groupDesign,
      groupLevel,
      friendCardBonus,
      totalScore,
      calculateScore,
    };
  },
};
</script>

<style>
.container {
  max-width: 600px;
  margin: auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+TC:wght@200..900&display=swap');
.partial-divider{
  width:70%;
  margin: 20px auto;
  border: none;
  border-top: 3px solid;
}
.huinnFont {
  #font-family: "huninnFont";
  font-family: "Noto Serif TC", serif;
}

</style>
